export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/white_blob-b70b7c90f2eab68af525a77403f927ba.png";